export enum Pages {
  ReceiptList = "/transactions",
  ReceiptDetails = "/transactions/:id",
  ReceiptListV2 = "/transactions-v2",
  ReceiptDetailsV2 = "/transactions-v2/:id",
}
// export const TRANSACTION_V2_FLAG = "TransactionMfRollout"
export const SEARCH_API_EXPERIMENTAL_FLAG = "RBPC-purchase-search-web"
export const MULTISITE_API_EXPERIMENTAL_FLAG = "multisite-launch"
